var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import InvoiceDialog from '../CreateDialogue/InvoiceDialog';
import EditInvoiceDialog from '../EditDialogue/EditInvoiceDialog';
import InvoiceBreakdown from './InvoiceBreakdown';
import InvoiceReport from './InvoiceReport';
import { logger, customBodyForExcelReport, handleExport, muiLoaderOptions} from '../../utils';
import AutoReport from "../Reports/AutoReport";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
const ExcelJS = require('exceljs');


export default function InvoiceTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [dataSet, setInvoices] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    const handleDialogCallback = (childData) => {
        fetch("api/invoice", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "invoice": [{
                    "POID": childData.POID,
                    "InvoiceNumber": childData.InvoiceNumber,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate,
                    "InvoiceDate": childData.InvoiceDate,
                    "Amount": childData.Amount
                }]
            })
        })
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {
        fetch("api/invoice", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "invoice": {
                    "ID": childData.ID,
                    "POID": childData.POID,
                    "InvoiceNumber": childData.InvoiceNumber,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate,
                    "InvoiceDate": childData.InvoiceDate,
                    "Amount": childData.Amount,
                    "IsVoid": childData.IsVoid,
                    "ExpenseID": childData.ExpenseID,
                    "UpdatePO": childData.UpdatePO
                }
            })
        })
        logger(childData);
        setRefresh(true);
    };
    const handleBreakdownCallback = () => {
        setRefresh(true);
    };
    const handleRefreshCallback = () => {
        setRefresh(true);
    };

    React.useEffect(() => {        
        if (refresh) {
            fetch('api/Invoice', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setInvoices(json);
					setIsLoading(false);
				})
            setRefresh(false);
        }

    })
	
	 const columns = [
        {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div style={{ display: "flex" }}>
                            <InvoiceBreakdown handleBreakdownCallback={handleBreakdownCallback} data={dataSet[dataIndex]} />
                            <EditInvoiceDialog handleEditCallback={handleEditCallback} handleRefreshCallback={handleRefreshCallback} data={dataSet[dataIndex]} invoices={dataSet} />
                            <InvoiceReport data={dataSet[dataIndex]} />
                        </div>
                    );
                }

            }
        },
        {
            name: "PO",
            label: "PO Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "InvoiceNumber",
            label: "Invoice",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "StartDate",
            label: "Start",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(dataSet[dataIndex].StartDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "EndDate",
            label: "End",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(dataSet[dataIndex].EndDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "Amount",
            label: "Amount",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                       parseFloat(dataSet[dataIndex].Amount).toFixed(2)
                    );
                }
            }
        },
        {
            name: "Remaining Amount",
            label: "Remaining Amount",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "IsBilled",
            options: {
                filter: true,
                sort: true,
                empty: true,
                filterOptions: {
                    names: ['NotBilled', 'Billed'],
                    logic: (isBilled, filters, row) => {
                        if(filters.includes('Billed')) {
                            return !isBilled;
                        } else if(filters.includes('NotBilled')) { // not billed
                            return isBilled;
                        }
                        return false;
                    }
                },
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            {(dataSet[dataIndex].IsBilled) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                }
            }
        },
		{
            name: "Void",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                        	{(dataSet[dataIndex].isVoid) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                }
            }
		}	
    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('InvoicerowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('InvoicerowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();
	
	const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
                const headers = customBuildHead();
                logger("headers", headers);
				for (var i = 0; i < dataSet.length; i++) {
					var eachRow = data[i].data;
					eachRow[3] =  moment.utc(eachRow[3]).format("MM/DD/YYYY")
					eachRow[4] =  moment.utc(eachRow[4]).format("MM/DD/YYYY")
				}
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'Invoice.xlsx', columnIndexToRemove:0})
			return false;
        },
        customToolbar: () => (
            <Box>
                <MuiPickersUtilsProvider utils={MomentUtils} locale="en">
                    <AutoReport handleRefreshCallback={handleRefreshCallback} />
                </MuiPickersUtilsProvider>
                <InvoiceDialog handleDialogCallback={handleDialogCallback} invoices={dataSet} />
            </Box>
        )
    };
    
    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

	return (
        
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="invoiceTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Invoice
                        </Typography>
                    }
                    data={isLoading ? [] :dataSet}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
        </Box>
        
    );
	
}